import { configureStore } from '@reduxjs/toolkit';
import filtersReducer from './filtersSlice';
import historicalReducer from './historicalSlice';
import surveyReducer from './surveySlice';
import languageReducer from './languageSlice';
import clientParamsReducer from './clientParamsSlice'
import improvementPlanReducer from './improvementPlanSlice';
import claimFormReducer from './claimFormSlice';
import currentUserReducer from './currentUserSlice';
import reportDefinitionReducer from './reportDefinitionSlice';

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    historical: historicalReducer,
    surveyForm: surveyReducer,
    improvementPlanForm: improvementPlanReducer,
    clientParamsForm: clientParamsReducer,
    language: languageReducer,
    claimForm: claimFormReducer,
    currentUserInfo: currentUserReducer,
    reportDefinitionForm: reportDefinitionReducer
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
